import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';
import CreateProjectForm from './Helpers/createProjectForm';
import CreateClientForm from './Helpers/createClientForm';
import Validator from '../../../Common/validator';
import Waves from 'node-waves'
import { isStringValid } from '../../../Util/stringValidator';
import DeleteModal from './deleteModal'
import HeadingSubtextContainer from '../../../HeadingSubtext/HeadingSubtextContainer'

class FirstColumnForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project: {
        id: null,
        name: "",
        number: ""
      },
      workplace: {
        name: "",
        touched: false
      },
      client: {
        id: null,
        name: "",
        contact: {
          id: null,
          name: ""
        },
        touched: false
      },
      projectSuggestionValue: {
        name: null,
        id: null
      },
      isDeleted: false
    }
  }
  componentWillMount = () => {
    const { defaultValues } = this.props;
    if (defaultValues)
      this.setState({
        project: {
          id: defaultValues.project.id,
          name: defaultValues.project.name,
          number: defaultValues.project.number
        },
        workplace: {
          name: defaultValues.workplace.name,
          touched: false
        },
        client: {
          id: defaultValues.client.id,
          name: defaultValues.client.name,
          contact: {
            id: defaultValues.client.contact.id,
            name: defaultValues.client.contact.name
          },
          touched: false
        }
      })
  };

  onSave = () => {
    if (this.isWorkplaceFormValid()) {
      this.props.saveWorkplace({
        project: this.refs.createProjectHelper.getValues(),
        workplace: this.state.workplace,
        client: this.refs.createClientHelper.getValues()
      })
    }
    else {
      return;
    }
  };
  onWorkplaceNameChange = (evt) => {
    this.setState({
      workplace: {
        name: evt.target.value,
        touched: true
      }
    })
  };

  closeDeleteModal = (bool) => {
    this.setState({
      isDeleted: bool
    })
  };

  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };

  onClientChange = (val) => {
    const { clients } = this.props;
    //if there is no value, do nothing
    if (!val) return;
    // find the client
    clients.forEach((client) => {
      if (client.id === val.parentId) {
        //find the contact on the client
        client.items.forEach((contact) => {
          if (contact.id === val.childId) {
            this.setState({
              client: {
                id: client.id,
                name: client.name,
                contact: {
                  id: contact.id,
                  name: contact.name
                }
              }
            })
          }
        })
      }
    })
  };
  isWorkplaceFormValid = () => {
    const { workplace } = this.state;
    let isValid = true;
    if (!this.refs.createProjectHelper.isValid())
      isValid = false

    //validate workplace name
    if (!isStringValid(workplace.name)) {
      this.setState({
        workplace: {
          name: "",
          touched: true
        }
      })
      isValid = false;
    }

    //validate client
    if (!this.refs.createClientHelper.isValid())
      isValid = false
    return isValid;
  };

  render() {
    const { projectNumberReserved, projectSuggestions, isProjectNumberReserved, getProjectSuggestions,
      toggleEdit, getClientSuggestions, clientSuggestions, contactSuggestions,
      getContactSuggestions, isSavingWorkplace, isLoading, isCreate } = this.props;
    const { project, workplace, client, isDeleted } = this.state;
    return (
      <div style={styles.container}>
        <div style={styles.iconsRow}>
          <div className="waves-btn"
            style={[styles.iconContainer, styles.iconActive]}
            onClick={toggleEdit}>
            <i className="fa fa-pencil"
              style={[styles.icon]}></i>
            <div style={styles.iconLabel}>Rediger</div>
          </div>
          <div style={styles.divider}></div>
          <div className="waves-btn"
            style={styles.iconContainer}
            onClick={this.onSave}>
            {isSavingWorkplace ?
              <i
                className="fa fa-spinner fa-spin"
                style={[styles.icon]} />
              :
              <i
                className="fa fa-floppy-o"
                style={styles.icon}></i>
            }
            <div style={styles.iconLabel}>Gem</div>
          </div>
        </div>
        <div style={styles.informationBoxes}>
          <div style={styles.stamdata}>Stamdata</div>
          <div style={styles.projectSmallText}>Sag</div>
          <CreateProjectForm
            ref="createProjectHelper"
            toggleIsCreateProject={this.toggleIsCreateProject}
            projectNumberReserved={projectNumberReserved}
            isProjectNumberReserved={isProjectNumberReserved}
            defaultValue={project}
            projectSuggestions={projectSuggestions}
            getProjectSuggestions={getProjectSuggestions}
          />
        </div>


        <div style={styles.informationBoxes}>
          <div style={styles.projectSmallText}>Bygherre</div>
          <CreateClientForm
            ref="createClientHelper"
            getClientSuggestions={getClientSuggestions}
            clientSuggestions={clientSuggestions}
            contactSuggestions={contactSuggestions}
            getContactSuggestions={getContactSuggestions}
            defaultValue={client}
          />
        </div>
        <div style={styles.informationBoxes}>
          <div style={styles.projectSmallText}>ID / Arbejdssted </div>
          <Validator
            isValid={(!workplace.touched || isStringValid(workplace.name))}
            msg={"Skal udfyldes"}>
            <input
              type="text"
              defaultValue={workplace.name}
              onChange={this.onWorkplaceNameChange}
              placeholder={workplace.name ? workplace.name : "ID / Arbejdssted"}
            />
          </Validator>
        </div>
        <HeadingSubtextContainer
          headingSubtexts={this.props.headingSubtexts}
          updateSubtext={(text, index) => this.props.updateSubtext(text, index)}
          updateHeading={(text, index) => this.props.updateHeading(text, index)}
          addHeadingSubtext={() => this.props.addHeadingSubtext()}
          style={{ position: 'relative', zIndex: 99, width: '100%', backgroundColor:'rgb(247, 247, 247)' }}
          subContainerStyle={{ width: '96%' }}
          headingStyle={{
            fontSize: 12,
            fontWeight: 500,
            width: '100%',
            backgroundColor: 'rgb(247, 247, 247)',
          }}
          subtextStyle={{
            marginTop: 8,
            marginBottom: 10,
            backgroundColor: 'white',
            border: 'none',
            boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
            borderRadius: '2px',
            width: '100%'
          }}
        />
        {!isCreate ?
          <div className="btn btn-danger waves-btn" style={styles.sletBtn}
            onClick={() => this.setState({ isDeleted: true })}>
            <i className="fa fa-trash-o" style={styles.trashIcon} aria-hidden="true"></i> Slet arbejdssted
            </div>
          :
          null
        }

        {isDeleted ?
          <DeleteModal
            closeDeleteModal={(bool) => this.closeDeleteModal(bool)}
            deleteWorkplace={this.props.deleteWorkplace}
            isLoading={isLoading}
          />
          :
          null
        }
      </div>
    );
  }
}


var styles = {
  container: {
    position: 'relative',
    zIndex: '100',
    paddingRight: '12px',
    height: '100%'
  },
  informationBoxes: {
    paddingBottom: '20px'
  },
  informationTitle: {
    fontWeight: '600',
    paddingBottom: '10px'
  },
  iconContainer: {
    fontSize: '22px',
    height: '45px',
    width: '50px',
    padding: '0px',
    textAlign: 'center',
    float: 'right',
    zIndex: '2',
    lineHeight: '20px'
  },
  iconsRow: {
    width: '100%',
    position: 'absolute',
    top: '0',
    right: '12px'
  },
  icon: {
    display: 'inline-block',
    width: '30px',
    height: '30px',
    lineHeight: '30px',
    cursor: 'pointer'
  },
  iconActive: {
    color: semanticColors.info
  },
  iconLabel: {
    fontSize: '12px',
    fontWeight: '600',
    marginTop: '-3px'
  },
  divider: {
    display: 'inline-block',
    float: 'right',
    width: '1px',
    height: '30px',
    marginTop: '10px',
    marginRight: '4px',
    marginLeft: '4px',
    backgroundColor: semanticColors.mainBackground
  },
  projectSmallText: {
    fontSize: '12px',
    fontWeight: '500',
    paddingBottom: '10px'
  },
  formLabels: {
    color: greyScaleColors.greyLight
  },
  informationDetailsEdit: {
    paddingBottom: '10px'
  },
  suggestProjectContainer: {
    width: '50%'
  },
  createProjectContainer: {
    lineHeight: '35px',
    textAlign: 'right',
    paddingRight: '45px',
    position: 'relative',
    fontSize: '12px'
  },
  createProjectPlusIcon: {
    textAlign: 'center',
    height: '30px',
    width: '30px',
    lineHeight: '30px',
    fontSize: '20px',
    position: 'absolute',
    top: '2px',
    right: '12px'
  },
  editProjectContainer: {
    minHeight: '150px'
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: 600,
  },
  spinner: {
    width: '20px',
    height: '20px'
  },
  stamdata: {
    paddingBottom: '5px'
  },
  sectionTitles: {
    paddingBottom: '10px'
  },
  sletBtn: {
    fontSize: '14px',
    height: '44px',
    lineHeight: '44px',
    padding: '0px',
    borderRadius: '2px',
    width: '100%'
  },
  trashIcon: {
    fontSize: '22px'
  },
  modal: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    zIndex: '11',
    backgroundColor: semanticColors.default,
    width: '240px',
    height: '220px',
    marginTop: '-110px',
    marginLeft: '-120px',
    textAlign: 'center',
    borderRadius: '2px',
    lineHeight: '40px',
    paddingTop: '10px'
  },
  overlay: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: '0',
    left: '0',
    backgroundColor: greyScaleColors.grey,
    opacity: '0.6',
    zIndex: '10'
  },
  closeIcon: {
    position: 'absolute',
    top: '0px',
    right: '0px',
    fontSize: '20px',
    height: '30px',
    lineHeight: '30px',
    width: '30px',
    zIndex: '10',
    cursor: 'pointer'
  },
  modalContent: {
    paddingTop: '70px'
  }
}
FirstColumnForm.propTypes = {
  defaultValues: PropTypes.shape({
    project: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      number: PropTypes.string.isRequired
    }),
    workplace: PropTypes.shape({
      name: PropTypes.string.isRequired
    }),
    client: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      contact: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
      }).isRequired
    })
  }),
  toggleEdit: PropTypes.func.isRequired,
  getProjectSuggestions: PropTypes.func.isRequired,
  projectNumberReserved: PropTypes.shape({
    reserved: PropTypes.bool.isRequired,
    projectNumber: PropTypes.string.isRequired
  }).isRequired,
  isProjectNumberReserved: PropTypes.func.isRequired,
  projectSuggestions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  })),
  saveWorkplace: PropTypes.func.isRequired,
  getClientSuggestions: PropTypes.func.isRequired,
  clientSuggestions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  contactSuggestions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  getContactSuggestions: PropTypes.func.isRequired,
  isSavingWorkplace: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
};
export default Radium(FirstColumnForm)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/firstColumnForm.jsx